module.exports = __webpack_public_path__ + "img/prestige-04.a823c7a6.png";